import React from 'react';
import { useStore } from '../../store';
import { useShallow } from 'zustand/react/shallow';
import { Alert, AlertDescription } from '@roger/ui-components';
import { AlertTriangle } from 'lucide-react';
import ProductUpdatesManagement from '../../components/internal-tools/ProductUpdatesManagement';
import { OnboardingTeamPanel } from '../../components/internal-tools/OnboardingTeamPanel';
import { DemoAgencySetupPanel } from '../../components/internal-tools/DemoAgencySetupPanel';
import { isDemoAgencySetupPanelEnabled } from '../../components/internal-tools/demoAgencySetupUi';
import SuperUserTab from '../../components/internal-tools/SuperUserTab';

const InternalTools: React.FC = () => {
  const { hasPermission, user } = useStore(
    useShallow(state => ({
      hasPermission: state.hasPermission,
      user: state.user,
    }))
  );

  const isStrawhat = user?.agency?.written_name === 'Strawhat';
  const isSuperUser = hasPermission('admin:super-user');

  if (!isStrawhat || !isSuperUser) {
    return (
      <div className='container mx-auto px-4 py-6'>
        <Alert className='border-red-200 bg-red-50'>
          <AlertDescription className='text-red-800 flex gap-2 items-center'>
            <AlertTriangle className='h-4 w-4 text-red-600' />
            You do not have permission to view this page. Please contact your
            administrator if you need access.
          </AlertDescription>
        </Alert>
      </div>
    );
  }

  return (
    <div className='space-y-6 p-6'>
      <div>
        <h1 className='text-3xl font-bold'>Internal Tools</h1>
        <p className='text-muted-foreground'>
          Manage agencies, users, and roles across the entire platform.
        </p>
      </div>

      <ProductUpdatesManagement />
      {isDemoAgencySetupPanelEnabled() && <DemoAgencySetupPanel />}
      <SuperUserTab />
      <OnboardingTeamPanel />
    </div>
  );
};

export default InternalTools;
